import { createApiClient } from '@/api/apiClient';
import { LID_API_BASE_URL } from '@/constants';
import { OverviewGet } from '@/types';

export const lidService = createApiClient({
  baseURL: `${LID_API_BASE_URL}/api/v1`,
});

export const getOverview = async () => {
  const { data } = await lidService.get<OverviewGet>('/overview');

  return data;
};
